import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { MessageService } from 'primeng/api';
import { LogExecucaoIntegracaoService } from 'src/services/log-execucao-integracao.service';
import { EstacaoService } from 'src/services/estacao.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { PermissoesService } from 'src/services/permissoes.service';
import * as moment from 'moment';

@Component({
    selector: 'app-log-execucao-integracao',
    templateUrl: './log-execucao-integracao.component.html',
    styleUrls: ['./log-execucao-integracao.component.scss'],
    standalone: false
})
export class LogExecucaoIntegracaoComponent implements OnInit, AfterViewInit {
  data: any[] = [];
  loading: boolean = false;
  
  // Filtros
  estacaoSelecionada: number | null = null;
  integracaoSelecionada: number | null = null;
  statusCodeSelecionado: string | null = null;
  dataInicio: Date | null = null;
  dataFim: Date | null = null;
  
  // Dropdowns
  dropDownEstacoes: any[] = [];
  dropDownIntegracoes: any[] = [];
  dropDownStatusCodes: any[] = [
    { label: '200 - Sucesso', value: '200' },
    { label: '400 - Bad Request', value: '400' },
    { label: '404 - Not Found', value: '404' },
    { label: '500 - Internal Server Error', value: '500' }
  ];
  
  // Paginação
  currentPage: number = 1;
  perPage: number = 10;
  totalRecords: number = 0;
  first: number = 0;
  
  // Flag para controlar se já foi filtrado
  dadosFiltrados: boolean = false;
  @ViewChild('tableWrapper', { static: false }) tableWrapper: ElementRef;
  scrollHeight: string = '600px';

  constructor(
    private logExecucaoIntegracaoService: LogExecucaoIntegracaoService,
    private estacaoService: EstacaoService,
    private integracaoService: IntegracaoService,
    private messageService: MessageService,
    protected permissaoService: PermissoesService,
  ) {}

  ngOnInit(): void {
    this.carregarEstacoes();
    this.carregarIntegracoes();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.calculateScrollHeight();
    }, 200);
  }

  calculateScrollHeight(): void {
    if (this.tableWrapper && this.tableWrapper.nativeElement) {
      const wrapperHeight = this.tableWrapper.nativeElement.offsetHeight;
      const calculatedHeight = wrapperHeight - 120;
      this.scrollHeight = `${Math.max(calculatedHeight, 300)}px`;
    }
  }

  carregarEstacoes(): void {
    this.estacaoService.lookup().subscribe({
      next: (res) => {
        const estacoes = res || [];
        this.dropDownEstacoes = estacoes.map((item: any) => ({
          label: item.descricao || `Estação ${item.id}`,
          value: item.id
        }));
      },
      error: (err) => {
        console.error('Erro ao carregar estações:', err);
      }
    });
  }

  carregarIntegracoes(): void {
    this.integracaoService.index().subscribe({
      next: (res) => {
        const integracoes = res.data || res || [];
        this.dropDownIntegracoes = integracoes.map((item: any) => ({
          label: item.descricao || `Integração ${item.id}`,
          value: item.id
        }));
      },
      error: (err) => {
        console.error('Erro ao carregar integrações:', err);
      }
    });
  }

  filtrar(): void {
    this.loading = true;
    this.currentPage = 1;
    this.first = 0;
    
    const filtros: any = {
      per_page: this.perPage,
      page: this.currentPage
    };

    if (this.estacaoSelecionada) {
      filtros.estacao_id = this.estacaoSelecionada;
    }
    if (this.integracaoSelecionada) {
      filtros.integracao_id = this.integracaoSelecionada;
    }
    if (this.statusCodeSelecionado) {
      filtros.status_code = this.statusCodeSelecionado;
    }
    if (this.dataInicio) {
      filtros.data_inicio = moment(this.dataInicio).format('YYYY-MM-DD');
    }
    if (this.dataFim) {
      filtros.data_fim = moment(this.dataFim).format('YYYY-MM-DD');
    }

    this.logExecucaoIntegracaoService.listar(filtros).subscribe({
      next: (res) => {
        this.data = res.data || [];
        this.totalRecords = res.total || 0;
        this.loading = false;
        this.dadosFiltrados = true;
        setTimeout(() => {
          this.calculateScrollHeight();
        }, 200);
        
        if (this.data.length === 0) {
          this.messageService.add({ 
            severity: 'info', 
            summary: 'Informação', 
            detail: 'Nenhum registro encontrado para os filtros selecionados' 
          });
        }
      },
      error: (err) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao carregar logs' 
        });
        this.loading = false;
        this.dadosFiltrados = true;
      }
    });
  }

  onPageChange(event: any): void {
    if (!this.dadosFiltrados) {
      return;
    }

    const page = (event.first / event.rows) + 1;
    this.first = event.first;
    this.perPage = event.rows;
    this.currentPage = page;
    
    const filtros: any = {
      per_page: this.perPage,
      page: this.currentPage
    };

    if (this.estacaoSelecionada) {
      filtros.estacao_id = this.estacaoSelecionada;
    }
    if (this.integracaoSelecionada) {
      filtros.integracao_id = this.integracaoSelecionada;
    }
    if (this.statusCodeSelecionado) {
      filtros.status_code = this.statusCodeSelecionado;
    }
    if (this.dataInicio) {
      filtros.data_inicio = moment(this.dataInicio).format('YYYY-MM-DD');
    }
    if (this.dataFim) {
      filtros.data_fim = moment(this.dataFim).format('YYYY-MM-DD');
    }

    this.loading = true;
    this.logExecucaoIntegracaoService.listar(filtros).subscribe({
      next: (res) => {
        this.data = res.data || [];
        this.totalRecords = res.total || 0;
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Erro', 
          detail: 'Erro ao carregar logs' 
        });
        this.loading = false;
      }
    });
  }

  formatarDataHora(dataHora: string): string {
    if (!dataHora) return 'N/A';
    return moment(dataHora).format('DD/MM/YYYY HH:mm:ss');
  }

  getStatusSeverity(statusCode: string): string {
    if (!statusCode) return '';
    const code = parseInt(statusCode);
    if (code >= 200 && code < 300) return 'success';
    if (code >= 400 && code < 500) return 'warn';
    if (code >= 500) return 'danger';
    return '';
  }

  isStatusWarning(statusCode: string): boolean {
    if (!statusCode) return false;
    const code = parseInt(statusCode);
    return code >= 400 && code < 500;
  }

  isStatusError(statusCode: string): boolean {
    if (!statusCode) return false;
    const code = parseInt(statusCode);
    return code >= 500;
  }

  getNomeEstacao(item: any): string {
    if (item.estacao && typeof item.estacao === 'object') {
      return item.estacao.descricao || `Estação ${item.estacao_id}`;
    }
    return item.estacao_id ? `Estação ${item.estacao_id}` : 'N/A';
  }

  getNomeIntegracao(item: any): string {
    if (item.integracao && typeof item.integracao === 'object') {
      return item.integracao.descricao || `Integração ${item.integracao_id}`;
    }
    return item.integracao_id ? `Integração ${item.integracao_id}` : 'N/A';
  }

}
